module.exports = __webpack_public_path__ + "img/Progress-Report-1-mobile.e0878582.png";